// extracted by mini-css-extract-plugin
export default {"cycleSelectorBadge":"JV6yMz","default":"i5AfLT","filled":"mPKOaN","text":"rGfj73","studio":"npPrj0","sale":"WYjO87","newUi":"cQ4QmJ","mobile":"D_yo5Z"};